// this is used to link to the various pages
const routes = {
  home: '/',
  blog: '/blog/',
  actionConditionsAirbnb: '/actievoorwaarden/',
  'actionConditionsAirbnbV2.0': '/actievoorwaarden-vriendenactie-2/',
  'actionConditionsAirbnbV2.1': '/actievoorwaarden-vriendenactie-2.2/',
  'actionConditionsAirbnbV2.2': '/actievoorwaarden-vriendenactie-2.2/',
  'actionConditionsAirbnbV3.0': '/actievoorwaarden-vriendenactie-3/',
  termsAndConditions: '/algemene-voorwaarden/',
  payed: '/betaling-gelukt/',
  contact: '/contact/',
  airbnbAssignment: '/opdracht-airbnb/',
  aboutUs: '/over-ons/',
  privacyDeclaration: '/privacyverklaring/',
  cookieDeclaration: '/cookies/',
  vacatures: '/jobs/',
  agencyFee: '/makelaarskosten/',
  airbnb: '/airbnb/',
  airbnbForm: '/airbnb/form/',
  airbnbDashboard: '/airbnb/dashboard/',
  airbnbAddBooking: '/airbnb/dashboard/add-booking/',
  airbnbAddBookingNotLoggedIn: '/airbnb/form/add-booking/',
  airbnbNoBookings: '/airbnb/dashboard/no-bookings/',
  airbnbDashboardSettings: '/airbnb/dashboard/settings/',
  airbnbConfirmEmail: '/airbnb/form/success/',
  airbnbFormSuccess: '/airbnb/form/share/',
  airbnbSuccess: '/airbnb/dashboard/success/',
  airbnbSuccessAdded: '/airbnb/dashboard/success-added/',
  airbnbNews: '/airbnb/dashboard/news/',
  airbnbReferralV2Info: '/airbnb/dashboard/referral-deal/',
  airbnbEmailLogin: '/airbnb/email-login/',
}

if (__BUILDFOR__ !== ' ') {
  Object.entries(routes).forEach(
    ([key, value]) => (routes[key] = value.replace(/^\/airbnb/, '')),
  )
}

if (__BUILDFOR__ === 'stichting') {
  routes.privacyDeclaration =
    'https://www.massaschadeconsument.nl/privacyverklaring'
  routes.airbnbDashboard = '/form/success/'
}

export default routes
